import { render, staticRenderFns } from "./Agencies.vue?vue&type=template&id=63986a9d&scoped=true"
import script from "./Agencies.vue?vue&type=script&lang=js"
export * from "./Agencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63986a9d",
  null
  
)

export default component.exports